import React from 'react';
import Icon from '../../../components/AppIcon';

const TransactionHistory = ({ payment, currentLanguage }) => {
  const translations = {
    en: {
      transactionDetails: 'Transaction Details',
      paymentIntentId: 'Payment Intent ID',
      stripeCustomerId: 'Stripe Customer ID',
      stripeChargeId: 'Stripe Charge ID',
      authorizationDate: 'Authorization Date',
      holdDate: 'Hold Date',
      releaseDate: 'Release Date',
      refundDate: 'Refund Date',
      amount: 'Amount',
      currency: 'Currency',
      status: 'Status',
      notAvailable: 'N/A'
    },
    ko: {
      transactionDetails: '거래 세부정보',
      paymentIntentId: '결제 의도 ID',
      stripeCustomerId: 'Stripe 고객 ID',
      stripeChargeId: 'Stripe 청구 ID',
      authorizationDate: '승인 날짜',
      holdDate: '보류 날짜',
      releaseDate: '해제 날짜',
      refundDate: '환불 날짜',
      amount: '금액',
      currency: '통화',
      status: '상태',
      notAvailable: '해당 없음'
    }
  };

  const t = translations?.[currentLanguage];

  const formatDate = (dateString) => {
    if (!dateString) return t?.notAvailable;
    const date = new Date(dateString);
    return date?.toLocaleDateString(currentLanguage === 'ko' ? 'ko-KR' : 'en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const formatCurrency = (amount) => {
    return currentLanguage === 'ko' 
      ? `₩${amount?.toLocaleString('ko-KR')}`
      : `$${amount?.toLocaleString('en-US')}`;
  };

  const transactionItems = [
    {
      label: t?.paymentIntentId,
      value: payment?.paymentIntentId || t?.notAvailable,
      icon: 'FileText'
    },
    {
      label: t?.stripeCustomerId,
      value: payment?.stripeCustomerId || t?.notAvailable,
      icon: 'User'
    },
    {
      label: t?.stripeChargeId,
      value: payment?.stripeChargeId || t?.notAvailable,
      icon: 'CreditCard'
    },
    {
      label: t?.authorizationDate,
      value: formatDate(payment?.authorizationDate),
      icon: 'CheckCircle'
    },
    {
      label: t?.holdDate,
      value: formatDate(payment?.holdDate),
      icon: 'Lock'
    },
    {
      label: t?.releaseDate,
      value: formatDate(payment?.releaseDate),
      icon: 'Unlock'
    },
    {
      label: t?.refundDate,
      value: formatDate(payment?.refundDate),
      icon: 'RefreshCcw'
    }
  ];

  return (
    <div className="bg-card rounded-xl border border-border p-6">
      <h3 className="text-lg md:text-xl font-heading font-semibold text-foreground mb-6">
        {t?.transactionDetails}
      </h3>
      <div className="space-y-4">
        {transactionItems?.map((item, index) => (
          <div key={index} className="flex items-start gap-3 p-3 bg-muted rounded-lg">
            <Icon name={item?.icon} size={18} color="var(--color-primary)" className="flex-shrink-0 mt-0.5" />
            <div className="flex-1 min-w-0">
              <p className="text-xs md:text-sm text-muted-foreground caption mb-1">
                {item?.label}
              </p>
              <p className="text-sm md:text-base font-medium text-foreground truncate">
                {item?.value}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TransactionHistory;